import { render, staticRenderFns } from "./GroupCategoryEdit.vue?vue&type=template&id=848d1182"
import script from "./GroupCategoryEdit.vue?vue&type=script&lang=js"
export * from "./GroupCategoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports